import React from 'react'
import { connect } from 'react-redux'
import {
  FormGroup, ControlLabel, FormControl, Form, Row, Col
} from 'react-bootstrap'

import { getReadyState, getCities, getCitiesByCountry } from '../selectors'
import CountrySelector from '../components/CountrySelector.jsx'
import { l } from '../../lib/Tools.js'
import isObjectEqual from '../../lib/isObjectEqual.js'
import { getText, nameOrTitle, translateCity } from '../lib/text.js'

type Props = {
  // mandatory
  cityId: string, 
  onChange: string => void, 

  // optional
  inline: ?boolean, 
  inlineForm: ?boolean, 
  labelWidth: ?number, 
  disabled: ?boolean,
  countryLabel: ?string,
  cityLabel: ?string,
  style: ?object, 

  // self-provided (connect)
  city: Object, 
  citiesByCountry: { [country:string]: Object[] }, 
  cities: { [country:string]: Object }, 
  ready: boolean, 
}

const DefaultWrapper = ({ child1, child2, style }) => (<div style={style}>{[child1, child2]}</div>) 
const InlineWrapper = ({ child1, child2, style }) => (<Row style={style}><Col md={6}>{child1}</Col><Col md={6}>{child2}</Col></Row>)
const InlineFormWrapper = ({ child1, child2, style }) => (<Form inline style={style}>{[child1, child2]}</Form>)

class CitySelector extends React.PureComponent
{
  props: Props;  

  changeCountry(countryId) {
    const firstCity = this.props.citiesByCountry[countryId][0]
    this.props.onChange(firstCity._id)
  }

  render() {
    const { 
      ready, cityId, onChange, city, citiesByCountry, cities, labelWidth, countryLabel, cityLabel, inline, inlineForm 
    } = this.props
    
    if (!ready || !city) return (<p>Loading...</p>)

    const Wrapper = (inlineForm && InlineFormWrapper) || (inline && InlineWrapper) || DefaultWrapper

    return (
      <Wrapper
        style={this.props.style || {}}
        child1={
          <CountrySelector
            value={city.country}
            onlyCountriesWithCities
            onChange={countryId => this.changeCountry(countryId)}
            labelWidth={labelWidth}
            disabled={this.props.disabled}
            label={countryLabel}
          />
        }
        child2={
          <FormGroup style={{display: "block", ...(inlineForm && {marginTop: 4})}}>
            <ControlLabel
              style={labelWidth ? { width: labelWidth } : {}}
            >
              {cityLabel || getText("Ciudad")}
            </ControlLabel>
            <FormControl
              className= "city-control"
              componentClass="select"
              value={cityId}
              onChange={evt => onChange(evt.target.value)}
              disabled={this.props.disabled}
            >
              {
                citiesByCountry[city.country].map(c => (
                  <option value={c._id} key={c._id}>
                    {translateCity(c) || `[${getText("Ciudad sin nombre")}]`}
                  </option>
                ))
              }
            </FormControl>
          </FormGroup>
        }
      />
    )
  }
}

CitySelector.defaultProps = {
  labelWidth: null
}

const mapStateToProps = (state, props) => ({
  city: getCities(state, props)[props.cityId] || getCities(state, props).Madrid, 
  cities: getCities(state, props), 
  citiesByCountry: getCitiesByCountry(state, props), 
  ready: getReadyState(state, props),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(CitySelector)
